export default {"src":"/_next/static/media/integration-ux-ui-service.9266859a.svg","height":411,"width":471,"blurWidth":0,"blurHeight":0};